import * as runtypes from 'runtypes';

export const LoginCertificateType = runtypes.Union(
  runtypes.Literal('none'),
  runtypes.Literal('optional'),
  runtypes.Literal('required')
);

export type LoginCertificateType = runtypes.Static<typeof LoginCertificateType>;
